import { render, staticRenderFns } from "./CivilStatus.vue?vue&type=template&id=35426018"
import script from "./CivilStatus.vue?vue&type=script&lang=js"
export * from "./CivilStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports